'use client';

import {styled} from "@mui/system";
import {Typography, TypographyProps} from "@mui/material";

const InfoItemTitle = styled(({...props }: TypographyProps) => (
    <Typography {...props} />
))(({ theme }) => ({
    textTransform: 'capitalize',
    fontWeight: '700',
    marginRight: '0.25rem',
    color: theme.palette.text.primary,
    ' .icon' : {
        marginRight: '.3rem',
        color: theme.palette.custom.slateGray,
        '&.scientific' : {
            color: theme.palette.primary.main
        }
    }
}));

export default InfoItemTitle;
